module.exports = __webpack_public_path__ + "static/img/camion.591106f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/camion.gif
// module id = SQNi
// module chunks = 1